const BAckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="#171717" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    )
}
export default BAckIcon;